export const topics = [
    {
      title: 'Creativity',
      selected: false,
      img: 'images/creativity.png' 
    },
    {
      title: 'Confidence',
      selected: false,
      img: 'images/confidence.png' 
    },
    {
      title: 'Self Reflection',
      selected: false,
      img: 'images/self_reflection.png' 
    },
    {
      title: 'Compassion',
      selected: false,
      img: 'images/compassion.png' 
    },
    {
      title: 'Kindness',
      selected: false,
      img: 'images/kindness.png' 
    },
    {
      title: 'Motivation',
      selected: false,
      img: 'images/motivation.png' 
    }
  ]
